import { createContext, useState, useContext, useEffect } from "react";
import { AuthContext } from "./AuthContext";

export const purchaseOrdersContext = createContext();

export const  PurchaseOrdersProvider = ({ children }) => {
    const [purchaseOrders, setPurchaseOrders] = useState([]);
    const [filters, setFilters] = useState({});
    const [billingEntities, setBillingEntities] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const {token} = useContext(AuthContext);
    const [sortBy, setSortBy] = useState("number");
    const [asc, setAsc] = useState(false);
    const [desc, setDesc] = useState(false);


    function filterPurchaseOrders(contents) {
        let purchaseOrdersCopy = contents;
        if (filters.billingEntityId) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                return element.billingEntityId === parseInt(filters.billingEntityId)
            });
        }
        if (filters.startIssueDate && filters.endIssueDate) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                return element.issueDate >= filters.startIssueDate && element.issueDate <= filters.endIssueDate
            });
        }
        if (filters.consumed) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                if (filters.consumed === "0")
                    return true;
                else if (filters.consumed === "1")
                    return element.valueRemaining > 0;
                return element.valueRemaining <= 0;
            })
        }
        if (filters.search) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                return element.number.includes(filters.search) || `${element.customer?.firstName} ${element.customer?.lastName}`.includes(filters.search)
            });
        }
        if (filters.currencyId && filters.currencyId[0]) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                return filters.currencyId.includes(element.currencyId.toString())
            });
        }
        if (filters.customerId && filters.customerId[0]) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                return filters.customerId.includes(element.customerId.toString())
            });
        }
        if (filters.archived) {
            purchaseOrdersCopy = purchaseOrdersCopy.filter(element => {
                return element.archived === parseInt(filters.archived)
            });
        }

        return purchaseOrdersCopy;
    }

    function sortPurchaseOrders(contents) {
        let purchaseOrdersCopy = contents;

        if (sortBy === "number") {
            purchaseOrdersCopy = purchaseOrdersCopy.sort((a, b) => {
                return a.number.localeCompare(b.number);
            });
        }
        else if (sortBy === "customer") {
            purchaseOrdersCopy = purchaseOrdersCopy.sort((a, b) => {
                return a.customer?.firstName?.localeCompare(b.customer?.firstName);
            });
        }
        else if (sortBy === "billingEntity") {
            purchaseOrdersCopy = purchaseOrdersCopy.sort((a, b) => {
                return a.billingEntity?.name?.localeCompare(b.billingEntity?.name);
            });
        }
        else if (sortBy === "totalValue") {
            purchaseOrdersCopy = purchaseOrdersCopy.sort((a, b) => {
                return a.totalValue - b.totalValue;
            });
        }
        else if (sortBy === "valueConsumed") {
            purchaseOrdersCopy = purchaseOrdersCopy.sort((a, b) => {
                return a.valueConsumed - b.valueConsumed;
            });
        }
        else if (sortBy === "valueRemaining") {
            purchaseOrdersCopy = purchaseOrdersCopy.sort((a, b) => {
                return a.valueRemaining - b.valueRemaining;
            });
        }
        if (desc) {
            purchaseOrdersCopy = purchaseOrdersCopy.reverse();
        }

        return purchaseOrdersCopy;
    }

    async function getPurchaseOrders() {
        try {
            const response = await fetch(process.env.REACT_APP_endPoint + '/v1/purchaseOrders', {
                method: "GET",
				credentials: "include"
			});

            if (response.ok) {
                const { purchaseOrders: contents } = await response.json();
                setPurchaseOrders(filterPurchaseOrders(sortPurchaseOrders(contents)));
            }
            else {
                setError("Failed to get POs");
            }
        }
        catch (e) {
            setError("Failed to get POs");
            console.error(e);
        }
    }

    async function getBillingEntities() {
        try {
            const response = await fetch(process.env.REACT_APP_endPoint + '/v1/billingEntities', {
                method: "GET",
				credentials: "include"
			});

            if (response.ok) {
                const { billingEntities: contents } = await response.json();
                setBillingEntities(contents);
            }
            else {
                setError("Failed to get Billing Entities");
            }
        }
        catch (e) {
            setError("Failed to get Billing Entities");
            console.error(e);
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            setError("");
            
            try {
                await Promise.all([
                    getPurchaseOrders(),
                    getBillingEntities()
                ]);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setLoading(false);
            }
        };
        
        fetchData();
    }, [filters, sortBy, asc, desc]);

    return (
        <purchaseOrdersContext.Provider value={{purchaseOrders, filters, setFilters, getPurchaseOrders, billingEntities, loading, error, sortBy, asc, desc, setSortBy, setAsc, setDesc}}>
            {children}
        </purchaseOrdersContext.Provider>
    );
}
